import { Navigate, useParams } from '@tanstack/react-router';
import { useResetPasswordMutation } from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useQueryHelper } from '@anytag/shared-hooks';
import { PasswordFormValues, ResetPasswordForm, SignInSignUpLayout } from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';

export const PasswordReset = () => {
  const { callResetPassword } = useResetPasswordMutation();
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const params = useParams({
    from: '/_public-routes/_password/password_reset/$token'
  });

  const token = params.token;

  if (!token) {
    return <Navigate to="/sign-in" />;
  }

  const handleSubmit: FormAction<PasswordFormValues>['onSubmit'] = async (payload) => {
    try {
      const result = await callResetPassword({
        variables: { input: { token, password: payload.password } }
      });

      if (result?.data?.resetPassword) {
        enqueueSnackbar(t('succeededInUpdatingPassword'), { variant: 'success' });
        navigate({ to: '/sign-in' });
      } else {
        enqueueSnackbar(t(UNEXPECTED_ERROR), { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar(t('failedToUpdatePassword'), { variant: 'error' });
      enqueueSnackbar(t(error?.message || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return (
    <SignInSignUpLayout
      footerProps={{ className: { display: 'none' } }}
      css={{ paddingTop: '82px', justifyContent: 'flex-start' }}
    >
      <ResetPasswordForm onSubmit={handleSubmit} />
    </SignInSignUpLayout>
  );
};
